import styled from 'styled-components';

export const TextBlockWrapper = styled.div<{
  type: 'xs' | 'sm' | 'md' | 'lg';
}>``;
